/* =====================================================================
   MX-modal-projeto.js  —  Quiz Proyectos Cocina — tienda MÉXICO (Shopify)

   Adaptado do modal-projeto.js da loja BR. Mantém o mesmo mecanismo de
   envio (POST direto na Forms Submission API v3 da HubSpot, lendo o cookie
   hubspotutk pra preservar atribuição) e a mesma navegação/validação.

   DIFERENÇAS EM RELAÇÃO À VERSÃO BR:
   1. 9 ETAPAS (era 11). Removidas as etapas 6 (eletrodomésticos) e 7
      (pia/bancada de mármore). As seguintes foram renumeradas:
        BR 8 (profundidade) -> MX 6   |   BR 9  (espaço pronto) -> MX 7
        BR 10 (data compra) -> MX 8   |   BR 11 (orçamento)     -> MX 9
   2. PROFUNDIDADE agora é INCONDICIONAL. No BR ela só aparecia pra quem
      dizia ter/querer bancada (etapa 7); sem essa etapa, a pergunta é
      sempre exibida. Os saltos condicionais foram removidos de
      nextStep/skipCurrentStep/goBack.
   3. TELEFONE mexicano: máscara (XX) XXXX-XXXX, 10 dígitos, DDI 52.
   4. LINHAS: só as 6 vendidas no MX (Agata, Glamy, Lux, Nice, Reims, Vik).
      Removidas Stella e Acordes. Cores recalculadas por linha; "Azul" saiu
      (nenhuma linha MX usa).
   5. ORÇAMENTO em pesos mexicanos (ver VALUE_MAP.orcamento).
   6. NACIONALIDADE: enviada FIXA como "México" em toda submissão.

   =====================================================================
   ⚠⚠⚠  QA — CONFIRME ANTES DO PRIMEIRO TESTE  ⚠⚠⚠
   A Forms Submission API DESCARTA (silenciosamente) qualquer campo cujo
   internal name NÃO exista na definição do form, e rejeita valores de enum
   que não batam 1:1 com as opções cadastradas. Status 200 + campo vazio =
   campo descartado. Então:

   1. FORMS: por decisão do time, o MX REAPROVEITA os forms do BR
      (FORM_ID 3292b6ad e FILE_FORM_ID f4ac284f). Consequência: os leads de
      BR e MX caem no MESMO formulário, então a separação entre países
      depende da propriedade de NACIONALIDADE (enviada fixa como México
      aqui). Se algum dia for preciso separar por origem, criar forms
      próprios e trocar os GUIDs.
      EARLY_CAPTURE_FORM_ID segue VAZIO de propósito (mesmo comportamento
      do BR) -> a captação antecipada do passo 1 é PULADA com segurança.
      Efeito: quem abandonar ANTES de clicar no X (que dispara recordExit)
      não gera lead. Decisão do time; para ativar, basta criar o form
      dedicado e preencher a constante.
   2. NACIONALIDADE: internal name "nacionalidade" e valor "México"
      CONFIRMADOS. Como BR e MX compartilham o form, é esta propriedade que
      separa os leads por país — confira no contato após o QA.
   3. ORÇAMENTO: as 4 faixas em MXN foram criadas na propriedade (mesma
      propriedade do BR, que agora tem as opções em R$ e em $). Confira que
      os rótulos do VALUE_MAP batem caractere por caractere com o que foi
      cadastrado — espaço ao redor do hífen, ponto de milhar, acento em
      "Más".
   4. RÓTULOS REAPROVEITADOS: os valores enviados (linha, cor, formato,
      profundidade, espaço) seguem em PORTUGUÊS de propósito — são as
      opções já cadastradas nas propriedades compartilhadas com o BR. Só a
      interface é traduzida. NÃO traduza o VALUE_MAP.
   5. TODOS os campos enviados precisam estar ADICIONADOS COMO CAMPO no
      form MX (não basta a propriedade existir no CRM) — incluindo os
      ocultos: madesa_email_consent, nacionalidade, etapa_de_desistencia,
      origem_de_cadastro_staging e origem_de_cadastro__crm__staging.
      O form de captação antecipada também precisa do campo nacionalidade.
   6. PUBLIQUE os forms. Alteração não publicada mantém a definição antiga
      ativa pra API — sintoma clássico: "adicionei o campo mas não chega".
   7. STAGING origem_de_cadastro: depende do WORKFLOW na HubSpot que copia
      *_staging -> propriedade original com ação "ADICIONAR valor" (nunca
      "definir"). Confirme que o workflow existe e está escopado ao form MX.
   ===================================================================== */
(function () {
	const win = /** @type {any} */ (window);
	if (win.__modalProjetoInitialized) return;
	win.__modalProjetoInitialized = true;

	// -------------------------------------------------------------------
	// CONFIG HUBSPOT
	// -------------------------------------------------------------------
	const PORTAL_ID = "39596724";
	const FORM_ID = "3292b6ad-3399-4361-b6b9-f2a469edf7a4"; // MESMO form do BR (decisão: MX reaproveita os forms do BR)
	const SUBMIT_URL = "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/" + FORM_ID;

	// ---------------------------------------------------------------------
	// FORM DEDICADO DE CAPTAÇÃO ANTECIPADA (passo 1)
	// ---------------------------------------------------------------------
	// MOTIVO: antes, captureLead() e submitForm() postavam os DOIS no mesmo
	// form (3292b6ad). Cada sessão completa do quiz gerava 2 linhas de
	// "Envio de formulário: CRM-Formulário LP - Projetos Cozinha" na timeline
	// do contato (uma no passo 1, outra no passo 11) — a duplicidade que o
	// Roberto viu no CRM. Agora a captação antecipada vai pra um form
	// SEPARADO, então o form principal (3292b6ad) só recebe 1 envio por
	// sessão completa, e a captação antecipada aparece como sua própria
	// atividade (não é mais confundida com "reenvio" do form principal).
	//
	// Para ATIVAR no futuro: crie o form dedicado na HubSpot (fase 2 do
	// playbook 03-criar-formulario-novo.md) com só estes campos:
	//   firstname, email, phone, gclid (oculto, se usado),
	//   sku (oculto, se usado), madesa_email_consent (oculto).
	// NÃO adicione legalConsentOptions/consentimento de comunicação neste
	// form — o POST de captação antecipada não envia esse bloco (ver
	// includeConsent: false na chamada dentro de captureLead()).
	// NÃO precisa de origem de cadastro aqui: a origem só é gravada 1x, no
	// envio final (submitForm -> ORIGIN_STAGING_NORMAL) ou na desistência
	// (recordExit), ambos no form principal.
	// ⚠ SE ATIVAR: o campo "nacionalidade" também precisa existir NESTE form,
	// senão o lead capturado no passo 1 entra sem país (buildEarlyCaptureFields
	// envia HIDDEN_FIELDS, que já inclui nacionalidade).
	// Publique o form, rode o extrator e cole o GUID abaixo.
	const EARLY_CAPTURE_FORM_ID = ""; // VAZIO de propósito — captação antecipada desativada (igual ao BR)
	const EARLY_CAPTURE_SUBMIT_URL = EARLY_CAPTURE_FORM_ID
		? "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/" + EARLY_CAPTURE_FORM_ID
		: "";

	// ---------------------------------------------------------------------
	// UPLOAD DE IMAGEM (passo 3) — FORM DEDICADO (confirmado por Roberto)
	// ---------------------------------------------------------------------
	// O form 3292b6ad não tem (e não terá) campo de upload de arquivo — o
	// textarea "link__form____texto" é outra coisa e não é usado por este
	// script. Vamos criar um form HubSpot dedicado só pra receber o arquivo
	// (email + campo de arquivo), igual ao "arquivo_neo" do NEO, usando o
	// mesmo mecanismo de <form>+<iframe> oculto no endpoint v2 legado (evita
	// CORS). Enquanto FILE_FORM_ID ficar "", o upload é PULADO com segurança
	// (não quebra o envio principal do quiz).
	const FILE_FORM_ID = "f4ac284f-17b8-49a3-a3bc-a7c2f4a2f62c"; // MESMO form de upload do BR

	// Campo de arquivo do form dedicado — MECANISMO IDÊNTICO AO NEO.
	// Um único campo recebe TODOS os arquivos: eles vão juntos num só
	// <input type="file" multiple>, numa só submissão. A propriedade da
	// HubSpot lista todos os arquivos (comprovado no arquivo_neo do Quiz NEO).
	const FILE_FIELD = "arquivos_cozinha";
	const LEGACY_FILE_UPLOAD_URL = "https://forms.hubspot.com/uploads/form/v2/" + PORTAL_ID + "/" + FILE_FORM_ID;

	// Campo de data (passo 10, <input type="month">) -> enviado como epoch ms UTC.
	// Internal name confirmado por Roberto (form novo, mesmas opções do form
	// de referência, só criado como form separado):
	const DATE_FIELD = "quando_voce_quer_realizar_a_compra_da_sua_cozinha_";

	// Campo de nacionalidade — enviado FIXO como "México" em toda submissão
	// deste formulário (loja MX). Fica separado do FIELD_MAP porque não vem
	// de nenhuma pergunta do quiz: é um valor constante da loja.
	//
	// Internal name e valor do enum CONFIRMADOS por Roberto.
	// Como BR e MX usam o MESMO formulário, esta propriedade é o que separa
	// os leads dos dois países no CRM — não altere o valor sem alinhar antes.
	// O acento em "México" é parte do valor: "Mexico" seria descartado em
	// silêncio pela Forms API (status 200, dado perdido).
	const NACIONALIDADE_FIELD = "nacionalidade";
	const NACIONALIDADE_VALUE = "México";

	// Mapa: chave interna do formData -> internal name da propriedade HubSpot.
	// IMPORTANTE (loja MX): as PROPRIEDADES e os RÓTULOS são os mesmos já
	// cadastrados na HubSpot (reaproveitados do BR) — por isso os internal
	// names abaixo e os valores do VALUE_MAP seguem em português. Só a
	// interface do quiz é traduzida para espanhol; o que vai pra HubSpot
	// continua batendo com as opções existentes.
	// Campos removidos nesta versão MX: eletrodomésticos (etapa 6) e
	// pia/bancada (etapa 7) — as etapas não existem mais no quiz.
	const FIELD_MAP = {
		nome: "firstname",
		email: "email",
		telefone: "phone",
		formato: "qual_o_formato_da_cozinha_dos_seus_sonhos_",
		linha: "qual_a_linha_que_voce_gostou_mais_",
		espaco: "o_seu_espaco_ja_esta_pronto_para_receber_a_sua_cozinha_nova",
		orcamento: "qual_o_orcamento_esta_disponivel_para_a_cozinha_dos_seus_sonhos_",
		cor: "qual_deve_ser_a_cor_da_sua_cozinha___multiplos_valores_",
		profundidade: "profundidade_da_bancada",
		data_compra: DATE_FIELD,
		// Medidas: não existem parede_1/2/3 separados neste form — vai tudo
		// combinado neste textarea único:
		medidasTexto: "possui_as_medidas___texto_",
		// Não existem campos pra gclid/sku neste form — ficam vazios
		// (o push() abaixo ignora automaticamente nomes vazios).
		gclid: "",
		sku: ""
	};

	// Mapa de VALORES (slug do DOM -> rótulo exato da opção na HubSpot).
	// Se um slug não estiver aqui, ele é enviado como veio.
	//
	// ⚠ ATENÇÃO (loja MX): os rótulos abaixo estão em PORTUGUÊS de propósito.
	// São as opções JÁ CADASTRADAS nas propriedades da HubSpot (compartilhadas
	// com o BR). A tradução para espanhol acontece só na interface (chaves de
	// tradução do Shopify) — o valor enviado tem que bater caractere por
	// caractere com a opção existente, senão a Forms API descarta em silêncio.
	const VALUE_MAP = {
		formato: {
			"linear": "Linear",
			"em-canto": "Em canto",
			"em-u": "Em U",
			"paralela": "Paralela",
			"outro": "Outro formato"
		},
		// Linhas disponíveis no México (Stella e Acordes não são vendidas lá)
		linha: {
			"agata": "Agata", "glamy": "Glamy", "lux": "Lux",
			"nice": "Nice", "reims": "Reims", "vik": "Vik"
		},
		// Cores disponíveis no México (Azul não é usada por nenhuma linha MX)
		cor: {
			"branco": "Branco", "cinza": "Cinza", "preto": "Preto",
			"crema": "Crema", "amadeirado": "Amadeirado", "verde": "Verde"
		},
		profundidade: { "52": "52cm", "60": "60cm" },
		espaco: { "sim": "Sim", "nao": "Não" },
		// Faixas de investimento em PESOS MEXICANOS — opções já cadastradas
		// na propriedade de orçamento (a mesma do BR, que agora tem faixas em
		// R$ e em $). Os valores abaixo precisam permanecer idênticos aos
		// rótulos cadastrados: espaço ao redor do hífen, ponto como separador
		// de milhar e acento em "Más".
		orcamento: {
			"20000-30000": "$20.000 - $30.000",
			"30000-40000": "$30.000 - $40.000",
			"40000-50000": "$40.000 - $50.000",
			"50000+": "Más $50.000"
		}
	};

	// Campos ocultos fixos — enviados em TODA submissão.
	// nacionalidade: valor constante da loja MX, para segmentar os leads
	// mexicanos no CRM independentemente da origem de cadastro.
	const HIDDEN_FIELDS = [
		{ name: "madesa_email_consent", value: "true" },                             // validado em produção no BR
		{ name: NACIONALIDADE_FIELD, value: NACIONALIDADE_VALUE },                   // separa MX de BR (mesmo form)
	];

	// Origem de cadastro (staging) — NÃO fica mais em HIDDEN_FIELDS.
	// ⚠ MOTIVO DA MUDANÇA: o workflow no HubSpot copia *_staging -> propriedade
	// original com ação "ADICIONAR valor" (não substituir). Antes, a captação
	// antecipada (captureLead, passo 1) já enviava a origem normal
	// "LP Cozinhas (Quiz)" e, se a pessoa desistisse depois, recordExit()
	// enviava a origem de desistência numa SEGUNDA submissão — o workflow
	// então ADICIONAVA as duas, resultando em "LP Cozinhas (Quiz), LP (Quiz)
	// Desistentes" juntos na propriedade final, mesmo quem só desistiu.
	// Agora a origem só é enviada UMA vez por sessão do quiz:
	//   - Lead CONCLUI o formulário -> origem normal enviada no submitForm().
	//   - Lead DESISTE no meio -> só a origem de desistência é enviada, no
	//     recordExit() (captureLead() não envia mais origem nenhuma).
	const ORIGIN_STAGING_NORMAL = [
		{ name: "origem_de_cadastro_staging", value: "LP Cozinhas (Quiz)" },         // validado em produção no BR
		{ name: "origem_de_cadastro__crm__staging", value: "LP (Quiz)" },            // validado em produção no BR
	];

	// Consentimento LGPD nativo do form.
	// ⚠ VALIDAR no teste: se a API reclamar de legalConsentOptions, é só remover
	// este bloco (ajuste também o subscriptionTypeId ao do portal, se preciso).
	const LEGAL_CONSENT = {
		consent: {
			consentToProcess: true,
			text: "Para prestar o serviço, precisamos da sua autorização para armazenar e processar seus dados pessoais.",
			communications: [
				{ value: true, subscriptionTypeId: 2924505825, text: "Concordo em receber comunicações da Madesa." }
			]
		}
	};

	// ⚠ REGRA DE NEGÓCIO (inclusive em desistência): este script NUNCA deve
	// enviar diretamente as propriedades REAIS "Origem de Cadastro" e
	// "Origem de Cadastro (CRM)" — nem no envio normal, nem no registro de
	// desistência (recordExit). Só as versões "*_staging" são enviadas; um
	// workflow no HubSpot é quem copia staging -> original com "adicionar
	// valor". Esta lista é uma blindagem: buildHubspotFields() remove
	// qualquer um destes nomes do payload final, mesmo que apareçam por
	// engano em HIDDEN_FIELDS, FIELD_MAP ou num `extra` no futuro.
	const NEVER_SEND_DIRECTLY = [
		"origem_de_cadastro",
		"origem_de_cadastro__crm_",
	];

	// Propriedade que registra em que etapa a pessoa desistiu (X no confirm-exit).
	// Adicionada por Roberto no form 3292b6ad como CAMPO oculto.
	const EXIT_FIELD = "etapa_de_desistencia";

	// data-step (número da etapa no DOM) -> slug exato cadastrado na propriedade.
	// Renumerado para a loja MX (9 etapas): as antigas etapas 6
	// (eletrodomésticos) e 7 (pia/bancada) foram removidas, então
	// profundidade/espaço/data/orçamento subiram duas posições.
	// ⚠ Os SLUGS continuam os mesmos já cadastrados na propriedade
	// etapa_de_desistencia — só o número da etapa mudou.
	const EXIT_STEP = {
		2: "formato",
		3: "medidas",
		4: "linha",
		5: "cor-frente",
		6: "pia-profundidade",
		7: "espaco-pronto",
		8: "data-compra",
		9: "orcamento",
	};

	function getHutk() {
		var m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
		return m ? m[2] : "";
	}

	(function () {
		try {
				const params = new URLSearchParams(window.location.search);
				const gclid = params.get("gclid");
				if (gclid) {
						sessionStorage.setItem("__gclid", gclid);
						win.__gclid = gclid;
				} else {
						win.__gclid = sessionStorage.getItem("__gclid") || "";
				}
		} catch (e) {
				win.__gclid = "";
		}
	})();

	/** @param {string} eventName @param {Record<string, unknown>} [params] */
	function trackProjetoEvent(eventName, params) {
		try {
			if (typeof win.trackEvent === "function") {
				win.trackEvent(eventName, params && typeof params === "object" ? params : {});
			}
		} catch (e) {
			/* noop */
		}

		if (eventName === "contato_projeto") {
			win.dataLayer = win.dataLayer || [];
			win.dataLayer.push({
					event: "lead_projeto",
					email: (formData.email || "").trim().toLowerCase(),
					phone_number: (formData.telefone || "").trim(),
					first_name: (formData.nome || "").trim(),
					gclid: win.__gclid || ""
			});
		}
	}

	/** @type {Record<number, string>} */
	const MODAL_STEP_ADVANCE_EVENTS = {
		1: "contato_projeto",
		2: "formato_cozinha_modal",
		3: "medidas_modal",
		4: "linha_cozinha_modal",
		5: "cor_cozinha_modal",
		6: "profundidade_modal",
		7: "pronto_modal",
		8: "periodo_modal",
	};

	const modalOverlay = document.getElementById("modal-projeto");
	const modalBackBtn = document.getElementById("modal-back-btn");
	const modalCloseBtn = document.getElementById("modal-close-btn");
	const modalConfirmOverlay = document.getElementById("modal-confirm-exit");
	const modalConfirmTitle = document.getElementById("modal-confirm-title");
	const modalConfirmMessage = document.getElementById("modal-confirm-message");
	const modalConfirmStayBtn = document.getElementById("modal-confirm-stay-btn");
	const modalConfirmSkipBtn = document.getElementById("modal-confirm-skip-btn");
	const modalConfirmLeaveBtn = document.getElementById("modal-confirm-leave-btn");
	// Botão "Cerrar" da tela de sucesso: REMOVIDO do template no MX (a tela
	// final só oferece WhatsApp e Continuar). O getElementById devolve null e
	// o listener abaixo é ignorado pelo guard — mantido caso o botão volte.
	const modalSuccessCloseBtn = document.getElementById("modal-success-close-btn");
	if (!modalOverlay || !modalBackBtn || !modalCloseBtn) {
		return;
	}

	/** @type {{
	 *   progressTpl?: string;
	 *   step3WallLabelTpl?: string;
	 *   step3PlaceholderCm?: string;
	 *   unitCmSuffix?: string;
	 *   uploadOne?: string;
	 *   uploadManyTpl?: string;
	 *   totalSteps?: number;
	 *   exitConfirm?: Record<string, {title: string; message: string; stay: string; leave: string}>;
	 * }} */
	let i18n = {};
	const i18nScript = document.getElementById("modal-projeto-i18n");
	if (i18nScript?.textContent) {
		try {
			i18n = JSON.parse(i18nScript.textContent.trim());
		} catch {
			i18n = {};
		}
	}

	const modal = modalOverlay;
	const backBtn = modalBackBtn;
	const closeBtn = modalCloseBtn;
	const MAX_FILE_MB = 100; // limite documentado da HubSpot pro campo de arquivo (igual ao NEO)
	const MAX_FILE_SIZE_BYTES = MAX_FILE_MB * 1024 * 1024;
	const STORAGE_KEY = "modal-projeto-progress";
	let isSubmitting = false;
	let leadCaptured = false; // captação antecipada do lead (uma vez por sessão)
	let openerProductId = "";

	/** @type {number} */
	let currentStep = 0;
	const totalSteps = typeof i18n.totalSteps === "number" && i18n.totalSteps > 0 ? i18n.totalSteps : 9;

	function saveProgress() {
		try {
			const progress = {
				step: currentStep,
				formData: formData,
				productId: openerProductId,
				timestamp: Date.now()
			};
			sessionStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
		} catch (e) {
			console.error("Failed to save progress:", e);
		}
	}

	function loadProgress() {
		try {
			const saved = sessionStorage.getItem(STORAGE_KEY);
			if (!saved) return null;
			const progress = JSON.parse(saved);
			// Check if progress is not older than 7 days
			const maxAge = 7 * 24 * 60 * 60 * 1000;
			if (Date.now() - progress.timestamp > maxAge) {
				sessionStorage.removeItem(STORAGE_KEY);
				return null;
			}
			return progress;
		} catch (e) {
			console.error("Failed to load progress:", e);
			return null;
		}
	}

	function clearProgress() {
		try {
			sessionStorage.removeItem(STORAGE_KEY);
		} catch (e) {
			console.error("Failed to clear progress:", e);
		}
	}

	// Textos-padrão do card de confirmação de saída, por etapa (2 a 9).
	// Ficam embutidos no JS pra o card NUNCA depender do i18n publicado — se o
	// bloco exitConfirm sumir do modal-projeto-i18n ou o JSON quebrar, o card
	// continua abrindo normalmente. Se o i18n TIVER exitConfirm[etapa], os
	// textos de lá têm prioridade (permite editar sem tocar no JS).
	const CONFIRM_EXIT_DEFAULTS = {
		2: { title: "Este paso ayuda a moldear tu proyecto de cocina soñada", message: "Elegir el formato de la cocina es esencial para mostrarte opciones que funcionan en tu espacio.", stay: "Quiero elegir un formato", skip: "Saltar esta pregunta", leave: "Continuar después" },
		3: { title: "¿No tienes las medidas o una imagen del espacio?", message: "Si aún no tienes las medidas o imágenes a la mano, puedes continuar ahora y enviárnoslas después.", stay: "Quiero indicar las medidas", skip: "Saltar esta pregunta", leave: "Continuar después" },
		4: { title: "¿Tienes dudas sobre qué línea combina contigo?", message: "Puedes elegir ahora o seguir y decidir la línea después.", stay: "Quiero elegir una línea", skip: "Saltar esta pregunta", leave: "Continuar después" },
		5: { title: "El color es el toque final", message: "El color de la cocina define mucho el estilo. ¿Qué tal dejar registrada tu preferencia?", stay: "Quiero elegir el color", skip: "Saltar esta pregunta", leave: "Continuar después" },
		6: { title: "Este detalle marca la diferencia en el proyecto", message: "Con la medida correcta, evitamos ajustes y retrabajos más adelante.", stay: "Voy a indicar la profundidad", skip: "Saltar esta pregunta", leave: "Continuar después" },
		7: { title: "¿Ya podemos instalar o aún vas a remodelar?", message: "Esta información ayuda a definir plazos y mostrarte el mejor camino.", stay: "Voy a responder ahora", skip: "Saltar esta pregunta", leave: "Continuar después" },
		8: { title: "¿Ya tienes una fecha en mente?", message: "Saber cuándo quieres comprar ayuda a adaptar la propuesta a tu momento.", stay: "Quiero elegir una fecha", skip: "Saltar esta pregunta", leave: "Continuar después" },
		9: { title: "Queremos mostrarte lo mejor dentro de tu presupuesto", message: "Con ese valor en mente, podemos armar una cocina que se ajuste a tu bolsillo.", stay: "Voy a indicar mi presupuesto", skip: "Saltar esta pregunta", leave: "Continuar después" },
	};

	function showConfirmExit() {
		if (!modalConfirmOverlay || !modalConfirmTitle || !modalConfirmMessage || !modalConfirmStayBtn || !modalConfirmLeaveBtn) {
			return false;
		}

		// Só mostra confirmação nas etapas 2 a 9.
		if (currentStep < 2 || currentStep > 9) {
			return false;
		}

		// Prioriza o texto do i18n publicado; se não existir (ou o i18n quebrou),
		// cai no texto-padrão embutido. Assim o card SEMPRE abre nas etapas 2-11.
		const i18nData = (i18n.exitConfirm && (i18n.exitConfirm[currentStep] || i18n.exitConfirm[String(currentStep)])) || null;
		const confirmData = i18nData || CONFIRM_EXIT_DEFAULTS[currentStep];
		if (!confirmData) {
			return false;
		}

		modalConfirmTitle.textContent = confirmData.title || "";
		modalConfirmMessage.innerHTML = confirmData.message || "";
		modalConfirmStayBtn.textContent = confirmData.stay || "Voltar";
		if (modalConfirmSkipBtn) {
			modalConfirmSkipBtn.textContent = confirmData.skip || "Pular esta pergunta";
		}
		modalConfirmLeaveBtn.textContent = confirmData.leave || "Continuar depois";

		modalConfirmOverlay.classList.remove("hidden");
		return true;
	}

	function hideConfirmExit() {
		if (modalConfirmOverlay) {
			modalConfirmOverlay.classList.add("hidden");
		}
	}

	function formatProgressFraction(step, total) {
		const tpl = i18n.progressTpl;
		if (tpl) {
			if (tpl.includes("__C__") || tpl.includes("__T__")) {
				return tpl.replace(/__C__/g, String(step)).replace(/__T__/g, String(total));
			}
			return tpl
				.replace(/\{\{\s*current\s*\}\}/gi, String(step))
				.replace(/\{\{\s*total\s*\}\}/gi, String(total));
		}
		return `${step} / ${total}`;
	}

	function wallLabel(index) {
		const tpl = i18n.step3WallLabelTpl;
		if (tpl) {
			return tpl.replace(/__N__/g, String(index));
		}
		return `Wall ${index}`;
	}

	function unitCmSuffix() {
		return typeof i18n.unitCmSuffix === "string" ? i18n.unitCmSuffix : " cm";
	}

	function placeholderStep3Cm() {
		return typeof i18n.step3PlaceholderCm === "string" ? i18n.step3PlaceholderCm : "__ cm";
	}

	function uploadStatusLabel(count) {
		if (count === 1) {
			return i18n.uploadOne || "";
		}
		if (count > 1 && typeof i18n.uploadManyTpl === "string") {
			return i18n.uploadManyTpl.replace(/__COUNT__/g, String(count));
		}
		return "";
	}
	/** @type {Record<string, any>} */
	const formData = {};

	/** @returns {NodeListOf<HTMLElement>} */
	const getStepElements = () => modal.querySelectorAll(".form-step");

	/** @type {Record<string, number>} */
	const STEP3_INPUT_COUNT_BY_FORMAT = {
		linear: 1,
		"em-canto": 2,
		"em-u": 3,
		paralela: 2,
	};

	function renderStep3ByFormat() {
		const step3InputsContainer = /** @type {HTMLElement | null} */ (modal.querySelector("[data-step3-inputs]"));
		const step3Illustration = /** @type {HTMLElement | null} */ (modal.querySelector("[data-step3-illustration]"));
		const step3MeasurePreview = /** @type {HTMLElement | null} */ (modal.querySelector(".step3-measure-preview"));
		const step3IllustrationImage = /** @type {HTMLImageElement | null} */ (modal.querySelector("[data-step3-illustration-image]"));
		if (!step3InputsContainer || !step3Illustration) {
			return;
		}

		const selectedFormat = `${formData.format || ""}`;
		const inputCount = STEP3_INPUT_COUNT_BY_FORMAT[selectedFormat] || 0;
		if (step3MeasurePreview) {
			step3MeasurePreview.hidden = inputCount === 0;
		}

		step3InputsContainer.innerHTML = "";

		for (let i = 1; i <= 3; i += 1) {
			delete formData[`parede${i}`];
		}

		for (let i = 1; i <= inputCount; i += 1) {
			const group = document.createElement("div");
			group.className = "form-group step3-form-group";

			const label = document.createElement("label");
			label.textContent = wallLabel(i);

			const input = document.createElement("input");
			input.type = "text";
			input.inputMode = "numeric";
			input.name = `parede${i}`;
			input.placeholder = placeholderStep3Cm();
			input.required = true;

			input.addEventListener("input", function () {
				const suf = unitCmSuffix();
				const numeric = this.value.replace(/[^0-9]/g, "");
				if (numeric) {
					const newValue = numeric + suf;
					this.value = newValue;
					this.setSelectionRange(numeric.length, numeric.length);
				} else {
					this.value = "";
				}
			});

			input.addEventListener("blur", function () {
				const suf = unitCmSuffix();
				const numeric = this.value.replace(/[^0-9]/g, "");
				this.value = numeric ? numeric + suf : "";
			});

			group.appendChild(label);
			group.appendChild(input);
			step3InputsContainer.appendChild(group);
		}

		/** @type {Record<string, string | undefined>} */
		const illustrationSrcByFormat = {
			linear: step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageLinear : "",
			"em-canto": step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageEmCanto : "",
			"em-u": step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageEmU : "",
			paralela: step3MeasurePreview ? step3MeasurePreview.dataset.step3ImageParalela : "",
		};
		const nextIllustrationSrc = illustrationSrcByFormat[selectedFormat] || "";

		if (step3IllustrationImage) {
			step3IllustrationImage.src = nextIllustrationSrc;
			step3IllustrationImage.hidden = !nextIllustrationSrc;
		}

		// Update skip/advance buttons based on measure inputs
		updateStep3Buttons();
	}

	/** @param {number} index */
	function getMeasureValue(index) {
		const raw = `${formData[`parede${index}`] || ""}`.trim();
		const value = raw.replace(/[^0-9]/g, "");
		return value || "0";
	}

	function isStepReady(step) {
		if (step === 1) {
			const nome = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="nome"]'));
			const email = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="email"]'));
			const telefone = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="telefone"]'));
			return !!(nome?.value.trim() && email?.value.trim() && telefone?.value.trim());
		}
		const stepEl = /** @type {HTMLElement | null} */ (modal.querySelector(`.form-step[data-step="${step}"]`));
		if (step === 2 || step === 7 || step === 9) {
			return !!stepEl?.querySelector('.option-btn.active');
		}
		if (step === 5) {
			return !!stepEl?.querySelector('.step5-color-btn.active');
		}
		if (step === 6) {
			const custom = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="step8_depth_custom"]'));
			return !!stepEl?.querySelector('.option-btn.active') || !!(custom?.value.replace(/[^0-9]/g, '').trim());
		}
		if (step === 8) {
			const dateInput = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="data-compra"]'));
			return !!(dateInput?.value);
		}
		return true;
	}

	function syncNextBtnState(step) {
		const stepsWithRequirements = [1, 2, 5, 6, 7, 8, 9];
		if (!stepsWithRequirements.includes(step)) return;
		const stepEl = /** @type {HTMLElement | null} */ (modal.querySelector(`.form-step[data-step="${step}"]`));
		if (!stepEl) return;
		const btn = /** @type {HTMLElement | null} */ (stepEl.querySelector('[data-next-step]:not(.step3-skip-btn):not(.step4-skip-btn)'));
		if (!btn) return;
		btn.classList.toggle('btn--pending', !isStepReady(step));
	}

	function updateStep3Buttons() {
		const advanceBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step3-advance-btn"));
		const skipBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step3-skip-btn"));
		if (!advanceBtn || !skipBtn) return;
		// Check if any measure input has value
		const hasMeasures = Array.from(modal.querySelectorAll('[name^="parede"]')).some((input) => {
			const inputEl = /** @type {HTMLInputElement} */ (input);
			return inputEl.value && inputEl.value.trim() !== '';
		});
		advanceBtn.style.display = hasMeasures ? "" : "none";
		skipBtn.style.display = hasMeasures ? "none" : "";
	}

	function updateStep4Buttons() {
		const advanceBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step4-next-btn"));
		const skipBtn = /** @type {HTMLElement | null} */ (modal.querySelector(".step4-skip-btn"));
		if (!advanceBtn || !skipBtn) return;
		const hasSelection = !!modal.querySelector('.form-step[data-step="4"] .option-btn.active');
		advanceBtn.style.display = hasSelection ? "" : "none";
		skipBtn.style.display = hasSelection ? "none" : "";
	}

	function renderStep5ByLine() {
		const selectedLine = `${formData.line || ""}`;
		const colorBtns = /** @type {NodeListOf<HTMLButtonElement>} */ (modal.querySelectorAll(".step5-color-btn"));
		colorBtns.forEach((btn) => {
			if (!selectedLine) {
				btn.hidden = false;
				return;
			}
			const lines = (btn.getAttribute("data-lines") || "").split(",");
			btn.hidden = !lines.includes(selectedLine);
			if (btn.hidden && btn.classList.contains("active")) {
				btn.classList.remove("active");
			}
		});
		// Resync formData after filter
		const activeColors = Array.from(modal.querySelectorAll(".step5-color-btn.active")).map((b) => b.getAttribute("data-value") || "");
		formData.color = activeColors.join(",");
		formData.cor = formData.color;
	}

	/** @param {Element | null} trigger */
	function getProductIdFromTrigger(trigger) {
		if (!trigger) {
			return "";
		}

		const selfProductId = trigger.getAttribute("data-product-id") || "";
		if (selfProductId.trim()) {
			return selfProductId.trim();
		}

		const cardWithProductId = /** @type {HTMLElement | null} */ (trigger.closest("[data-product-id]"));
		if (!cardWithProductId) {
			return "";
		}

		const productId = cardWithProductId.getAttribute("data-product-id") || "";
		return productId.trim();
	}

	/**
	 * Lista acumulada de arquivos do passo 3. Necessária porque o
	 * <input type="file"> substitui input.files a cada nova seleção — sem
	 * isso, anexar um 2º arquivo apagaria o 1º.
	 * @type {File[]}
	 */
	let uploadedFiles = [];

	function getUploadInput() {
		return /** @type {HTMLInputElement | null} */ (
			modal.querySelector('input[name="step3_space_file"]')
		);
	}

	/** Reescreve input.files com a lista acumulada (mantém os dois em sincronia). */
	function syncUploadInput() {
		const input = getUploadInput();
		if (!input) return;
		try {
			const dt = new DataTransfer();
			uploadedFiles.forEach((f) => dt.items.add(f));
			input.files = dt.files;
		} catch (err) {
			// Navegador sem suporte a DataTransfer: uploadedFiles continua
			// sendo a fonte de verdade pro envio, então o upload não quebra.
			console.error("[modal-projeto] Não foi possível sincronizar input.files.", err);
		}
	}

	/** @param {number} bytes */
	function formatFileSize(bytes) {
		if (bytes < 1024) return `${bytes} B`;
		if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
		return `${(bytes / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
	}

	/**
	 * Renderiza a lista de arquivos anexados, cada um com botão de remover.
	 * Usa textContent (nunca innerHTML) pro nome do arquivo — nome de arquivo
	 * é conteúdo controlado pelo usuário e não deve ser interpretado como HTML.
	 */
	function renderUploadList() {
		const list = modal.querySelector("[data-upload-list]");
		if (!list) return;

		list.innerHTML = "";

		if (!uploadedFiles.length) {
			list.hidden = true;
			return;
		}
		list.hidden = false;

		uploadedFiles.forEach((file, index) => {
			const item = document.createElement("li");
			item.className = "step3-upload-item";

			const name = document.createElement("span");
			name.className = "step3-upload-item__name";
			name.textContent = file.name;
			name.title = file.name;

			const size = document.createElement("span");
			size.className = "step3-upload-item__size";
			size.textContent = formatFileSize(file.size);

			const remove = document.createElement("button");
			remove.type = "button";
			remove.className = "step3-upload-item__remove";
			remove.setAttribute("data-upload-remove", String(index));
			remove.setAttribute("aria-label", `Remover ${file.name}`);
			remove.textContent = "\u00D7"; // ×

			item.appendChild(name);
			item.appendChild(size);
			item.appendChild(remove);
			list.appendChild(item);
		});
	}

	/** Atualiza o texto com a contagem/nomes dos arquivos anexados + a lista. */
	function renderUploadStatus() {
		formData.space_file = uploadedFiles.map((f) => f.name).join(", ");
		const label = uploadStatusLabel(uploadedFiles.length);
		modal.querySelectorAll("[data-upload-filename]").forEach((el) => {
			el.textContent = label;
		});
		renderUploadList();
	}

	/** @param {number} index */
	function removeUploadFile(index) {
		if (index < 0 || index >= uploadedFiles.length) return;
		uploadedFiles.splice(index, 1);
		syncUploadInput();
		renderUploadStatus();
	}

	function getUploadFiles() {
		return uploadedFiles.slice();
	}

	/** @param {File[]} files */
	function validateUploadFiles(files) {
		if (!files.length) return null;

		let totalBytes = 0;

		for (const file of files) {
			// Aceita imagens e PDF. Alguns navegadores/SOs não informam o MIME
			// em certos casos, então o fallback checa a extensão .pdf.
			const isImage = file.type.startsWith("image/");
			const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
			if (!isImage && !isPdf) {
				return "Envía solo imágenes o PDF en el campo de archivo adjunto del espacio.";
			}
			if (file.size > MAX_FILE_SIZE_BYTES) {
				return `El archivo "${file.name}" debe pesar máximo ${MAX_FILE_MB}MB.`;
			}
			totalBytes += file.size;
		}

		// Limite do conjunto: vários arquivos somados também respeitam os 100MB.
		if (totalBytes > MAX_FILE_SIZE_BYTES) {
			const totalMb = Math.ceil(totalBytes / (1024 * 1024));
			return `Los archivos suman ${totalMb}MB. El total debe pesar máximo ${MAX_FILE_MB}MB.`;
		}

		return null;
	}

	// -------------------------------------------------------------------
	// ENVIO — HubSpot Forms Submission API (padrão NEO)
	// -------------------------------------------------------------------

	/** slug do DOM -> rótulo HubSpot (passthrough se não mapeado) */
	function mapVal(map, slug) {
		if (slug === undefined || slug === null || slug === "") return "";
		return map && Object.prototype.hasOwnProperty.call(map, slug) ? map[slug] : slug;
	}

	/**
	 * Monta o array de { name, value } no formato da Forms API a partir do formData.
	 * Só inclui campos com valor. Multi-select vai como "a;b;c".
	 * @param {Array<{name:string,value:string}>} [extra] — campos extras anexados ao final.
	 *   Se um nome em `extra` já tiver sido enviado antes (ex.: origem_de_cadastro_staging),
	 *   o valor de `extra` SOBRESCREVE o anterior (usado p/ marcar desistentes).
	 */
	function buildHubspotFields(extra) {
		const fieldsMap = new Map();
		const push = (name, value) => {
			if (name && value !== "" && value != null) fieldsMap.set(name, String(value));
		};

		// Passo 1 — dados pessoais
		push(FIELD_MAP.nome, `${formData.nome || ""}`.trim());
		push(FIELD_MAP.email, `${formData.email || ""}`.trim());
		let tel = `${formData.telefone || ""}`.replace(/\D/g, ""); // só dígitos, ex.: "51997942579"
		if (tel && tel.indexOf("52") !== 0) tel = "52" + tel;  // DDI do México       // garante o DDI na frente
		push(FIELD_MAP.telefone, tel);

		// Passo 2 — formato
		push(FIELD_MAP.formato, mapVal(VALUE_MAP.formato, `${formData.formato || ""}`));

		// Passo 3 — medidas das paredes: o form 3292b6ad NÃO tem parede_1/2/3
		// separados, só um textarea único ("possui_as_medidas___texto_").
		// Combina as paredes preenchidas num texto tipo "Parede 1: 300cm, Parede 2: 250cm".
		{
			const paredesTexto = [];
			for (let i = 1; i <= 3; i += 1) {
				const digits = `${formData[`parede${i}`] || ""}`.replace(/[^0-9]/g, "");
				if (digits) paredesTexto.push(`Parede ${i}: ${digits}cm`);
			}
			push(FIELD_MAP.medidasTexto, paredesTexto.join(", "));
		}

		// Passo 4 — linha (opcional)
		push(FIELD_MAP.linha, mapVal(VALUE_MAP.linha, `${formData.line || ""}`));

		// Passo 5 — cor (multi, até 2)
		const cores = `${formData.cor || ""}`
			.split(",")
			.map((s) => s.trim())
			.filter(Boolean)
			.map((s) => mapVal(VALUE_MAP.cor, s));
		push(FIELD_MAP.cor, cores.join(";"));

		// Etapa 6 — profundidade ("52"/"60" -> "52cm"/"60cm"; custom "NNcm" passa direto)
		push(FIELD_MAP.profundidade, mapVal(VALUE_MAP.profundidade, `${formData.profundidade || ""}`));

		// Etapa 7 — espaço pronto
		push(FIELD_MAP.espaco, mapVal(VALUE_MAP.espaco, `${formData.espacoPronto || ""}`));

		// Etapa 8 — data (month "YYYY-MM" -> epoch ms UTC)
		const dc = `${formData.data_compra || ""}`.trim();
		if (dc) {
			const p = dc.split("-");
			const day = p[2] ? +p[2] : 1;
			push(FIELD_MAP.data_compra, String(Date.UTC(+p[0], +p[1] - 1, day)));
		}

		// Etapa 9 — orçamento
		push(FIELD_MAP.orcamento, mapVal(VALUE_MAP.orcamento, `${formData.orcamento || ""}`));

		// Opcionais (só se o nome estiver configurado no FIELD_MAP)
		push(FIELD_MAP.gclid, win.__gclid || "");
		push(FIELD_MAP.sku, `${openerProductId || ""}`.trim());

		// Ocultos fixos (staging origem + consent)
		HIDDEN_FIELDS.forEach((f) => push(f.name, f.value));

		// Campos extras (ex.: etapa_de_desistencia, ou override de origem p/ desistentes)
		// — processados por último, então SOBRESCREVEM valores já definidos acima.
		if (extra) extra.forEach((f) => push(f.name, f.value));

		// Blindagem final: garante que os campos REAIS de origem nunca saiam
		// neste payload, em nenhum cenário (normal, captureLead ou recordExit).
		NEVER_SEND_DIRECTLY.forEach((name) => fieldsMap.delete(name));

		return Array.from(fieldsMap, ([name, value]) => ({ name, value }));
	}

	/**
	 * Monta o array de { name, value } só com os campos do PASSO 1 — usado
	 * exclusivamente pela captação antecipada (captureLead), que agora vai
	 * pro form dedicado EARLY_CAPTURE_FORM_ID. Não inclui origem de cadastro
	 * (isso só acontece no envio final ou na desistência) nem qualquer campo
	 * das etapas 2-11, já que elas ainda não foram respondidas neste ponto.
	 */
	function buildEarlyCaptureFields() {
		const fieldsMap = new Map();
		const push = (name, value) => {
			if (name && value !== "" && value != null) fieldsMap.set(name, String(value));
		};

		push(FIELD_MAP.nome, `${formData.nome || ""}`.trim());
		push(FIELD_MAP.email, `${formData.email || ""}`.trim());
		let tel = `${formData.telefone || ""}`.replace(/\D/g, "");
		if (tel && tel.indexOf("52") !== 0) tel = "52" + tel;  // DDI do México
		push(FIELD_MAP.telefone, tel);

		// Opcionais (só se o nome estiver configurado no FIELD_MAP)
		push(FIELD_MAP.gclid, win.__gclid || "");
		push(FIELD_MAP.sku, `${openerProductId || ""}`.trim());

		// Consentimento — mesmo campo oculto do form principal.
		HIDDEN_FIELDS.forEach((f) => push(f.name, f.value));

		NEVER_SEND_DIRECTLY.forEach((name) => fieldsMap.delete(name));

		return Array.from(fieldsMap, ([name, value]) => ({ name, value }));
	}

	/** @param {Array<{name:string,value:string}>} fields */
	function debugFields(fields) {
		fields.forEach((f) => console.log("[modal-projeto]", f.name, f.value));
	}

	/**
	 * POST na Forms API. Retorna Promise; lança erro em resposta !ok.
	 * @param {Array<{name:string,value:string}>} fields
	 * @param {{ url?: string, ipAddress?: string, includeConsent?: boolean }} [opts]
	 *   url            — endpoint de destino (default: SUBMIT_URL, form principal).
	 *   ipAddress      — IP best-effort pro context.
	 *   includeConsent — se false, NÃO envia legalConsentOptions (usado no form
	 *                    dedicado de captação antecipada, que não tem esse módulo
	 *                    configurado). Default: true (mantém o form principal
	 *                    como estava).
	 */
	function postToHubspot(fields, opts) {
		opts = opts || {};
		const url = opts.url || SUBMIT_URL;
		const includeConsent = opts.includeConsent !== false;
		const ipAddress = opts.ipAddress;

		const ctx = { pageUri: window.location.href, pageName: document.title };
		const hutk = getHutk();
		if (hutk) ctx.hutk = hutk; // só envia hutk se o cookie existir (API rejeita "")
		if (ipAddress) ctx.ipAddress = ipAddress;

		const payload = {
			fields: fields,
			context: ctx,
		};
		if (includeConsent) {
			payload.legalConsentOptions = LEGAL_CONSENT;
		}

		return fetch(url, {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify(payload),
		}).then((res) =>
			res
				.json()
				.catch(() => ({}))
				.then((data) => {
					if (!res.ok) {
						console.error("[modal-projeto] Falha no envio", res.status, data);
						throw new Error((data && data.message) || `No fue posible enviar el formulario (${res.status}).`);
					}
					return data;
				}),
		);
	}

	/**
	 * Captação antecipada do lead: ao avançar do passo 1, cria/atualiza o
	 * contato já com nome/e-mail/telefone + ocultos, best-effort.
	 *
	 * Vai para o form DEDICADO (EARLY_CAPTURE_FORM_ID), separado do form
	 * principal (3292b6ad) — isso evita que cada sessão completa do quiz
	 * gere 2 linhas de "Envio de formulário" pro MESMO form na timeline do
	 * contato (era a causa da duplicidade vista no CRM).
	 *
	 * Enquanto EARLY_CAPTURE_FORM_ID não estiver configurado, a captação é
	 * pulada com segurança — o quiz continua funcionando normalmente e o
	 * envio final (submitForm) não depende disso.
	 */
	function captureLead() {
		if (leadCaptured) return;
		leadCaptured = true;

		if (!EARLY_CAPTURE_SUBMIT_URL) {
			console.info(
				"[MX-modal-projeto] Captação antecipada desativada por decisão do time " +
				"(EARLY_CAPTURE_FORM_ID vazio, igual ao BR). Não é erro de configuração."
			);
			return;
		}

		try {
			postToHubspot(buildEarlyCaptureFields(), { url: EARLY_CAPTURE_SUBMIT_URL, includeConsent: false }).catch((err) => {
				console.error("[modal-projeto] Captação inicial do lead falhou (quiz segue normalmente).", err);
			});
		} catch (err) {
			console.error("[modal-projeto] Erro inesperado na captação inicial do lead.", err);
		}
	}

	/**
	 * Registra a etapa em que a pessoa desistiu (botão "Sair do formulário" no
	 * card de confirmação), junto com os campos já preenchidos até então.
	 * Nesse cenário específico, sobrescreve origem_de_cadastro_staging e
	 * origem_de_cadastro__crm__staging com "LP (Quiz) Desistentes" (em vez dos
	 * valores normais de HIDDEN_FIELDS), pra segmentar quem abandonou o quiz.
	 * IMPORTANTE: aqui (como em qualquer outra submissão) só as propriedades
	 * *_staging são preenchidas. Os campos reais "Origem de Cadastro" e
	 * "Origem de Cadastro (CRM)" nunca são enviados por este script — quem
	 * atualiza eles é o workflow de staging->original no HubSpot (ver
	 * NEVER_SEND_DIRECTLY, que blinda isso em buildHubspotFields()).
	 * Este POST continua indo pro form PRINCIPAL (3292b6ad) — só a captação
	 * antecipada (captureLead) foi movida pro form dedicado.
	 * Best-effort: dispara e não bloqueia o fechamento do modal.
	 * @param {string} stepSlug
	 */
	function recordExit(stepSlug) {
		if (!stepSlug) return;
		try {
			const DESISTENTE_ORIGEM = "LP (Quiz) Desistentes";
			postToHubspot(
				buildHubspotFields([
					{ name: EXIT_FIELD, value: stepSlug },
					{ name: "origem_de_cadastro_staging", value: DESISTENTE_ORIGEM },
					{ name: "origem_de_cadastro__crm__staging", value: DESISTENTE_ORIGEM },
				]),
			).catch((err) => {
				console.error("[modal-projeto] Registro da etapa de desistência falhou.", err);
			});
		} catch (err) {
			console.error("[modal-projeto] Erro inesperado ao registrar etapa de desistência.", err);
		}
	}

	/**
	 * Upload dos arquivos do passo 3 pro form dedicado da HubSpot.
	 *
	 * UMA submissão com UM campo de arquivo recebendo TODOS os anexos —
	 * mecanismo idêntico ao do Quiz NEO (arquivo_neo), onde uma única
	 * propriedade lista vários arquivos. Uma submissão por lead, então o
	 * histórico do contato não infla.
	 *
	 * Enviado via <form>+<iframe> ocultos no endpoint v2 legado (contorna
	 * CORS por ser POST tradicional de formulário, não AJAX).
	 *
	 * Best-effort: qualquer falha só é logada e NUNCA impede o envio principal.
	 * Se FILE_FORM_ID não estiver configurado, não faz nada.
	 * @param {string} email
	 * @param {File[]} files
	 */
	function submitFileViaHiddenIframe(email, files) {
		if (!FILE_FORM_ID) return; // upload ainda não configurado -> pula com segurança
		if (!files || !files.length) return;

		try {
			// IFRAME REAPROVEITADO por ID fixo — idêntico ao NEO.
			// NÃO criar um iframe novo por envio nem removê-lo depois: o iframe
			// é o alvo (target) do POST, e destruí-lo antes da HubSpot terminar
			// de processar interrompe o upload no meio.
			const IFRAME_NAME = "mpq-file-upload-frame";
			let iframe = document.getElementById(IFRAME_NAME);
			if (!iframe) {
				iframe = document.createElement("iframe");
				iframe.name = IFRAME_NAME;
				iframe.id = IFRAME_NAME;
				iframe.style.display = "none";
				document.body.appendChild(iframe);
			}

			const form = document.createElement("form");
			form.action = LEGACY_FILE_UPLOAD_URL;
			form.method = "POST";
			form.enctype = "multipart/form-data";
			form.target = IFRAME_NAME;
			form.style.display = "none";

			const emailInput = document.createElement("input");
			emailInput.type = "hidden";
			emailInput.name = "email";
			emailInput.value = email || "";
			form.appendChild(emailInput);

			const ctxInput = document.createElement("input");
			ctxInput.type = "hidden";
			ctxInput.name = "hs_context";
			ctxInput.value = JSON.stringify({
				pageUri: window.location.href,
				pageName: document.title,
				hutk: getHutk(),
			});
			form.appendChild(ctxInput);

			// UM input com TODOS os arquivos (multiple) — igual ao NEO.
			// arquivos_cozinha é propriedade do tipo ARQUIVO (mesma natureza do
			// arquivo_neo), então recebe vários arquivos na mesma submissão.
			const fileInput = document.createElement("input");
			fileInput.type = "file";
			fileInput.name = FILE_FIELD;
			fileInput.multiple = true;
			const dt = new DataTransfer();
			Array.prototype.forEach.call(files, (f) => dt.items.add(f));
			fileInput.files = dt.files;
			form.appendChild(fileInput);

			document.body.appendChild(form);

			// DIAGNÓSTICO: loga o que está sendo postado. A resposta da HubSpot
			// não é legível via JS (iframe cross-origin) — veja o POST na aba
			// Network do DevTools, filtrando por "uploads".
			console.log(
				"[modal-projeto] UPLOAD →", LEGACY_FILE_UPLOAD_URL,
				"\n  campo:", FILE_FIELD,
				"\n  email:", email || "(vazio)",
				"\n  arquivos:", Array.prototype.map.call(files, (f) => `${f.name} (${f.size}b)`).join(" | "),
			);

			form.submit();
			// Remove SÓ o form, mantendo o iframe vivo (igual ao NEO).
			// 30s: margem pro upload em conexão mais lenta.
			window.setTimeout(() => form.remove(), 30000);
		} catch (err) {
			console.error("[modal-projeto] Falha ao enviar arquivos via iframe oculto — quiz principal segue normalmente.", err);
		}
	}

	/** @param {boolean} loading */
	function setSubmitLoading(loading) {
		const submitBtn = /** @type {HTMLButtonElement | null} */ (modal.querySelector("[data-submit]"));
		if (!submitBtn) {
			return;
		}

		submitBtn.disabled = loading;
		submitBtn.setAttribute("aria-busy", loading ? "true" : "false");
	}

	/** @param {number} step */
	function showStep(step) {
		getStepElements().forEach((el) => el.classList.remove("active"));

		const stepElements = getStepElements();
		let activeStepElement = null;
		if (stepElements[step]) {
			activeStepElement = stepElements[step];
			activeStepElement.classList.add("active");
		}

		const modalContainer = modal.querySelector(".modal-container");
		if (modalContainer) {
			const isSuccessStep = activeStepElement?.getAttribute("data-step") === "success";
			modalContainer.classList.toggle("is-success-step", isSuccessStep);
		}

		if (step > 0 && step <= totalSteps) {
			modal.querySelectorAll("#progress-counter").forEach((el) => {
				el.textContent = formatProgressFraction(step, totalSteps);
			});
		}

		const modalContent = modal.querySelector(".modal-content");
		if (modalContent) {
			modalContent.scrollTop = 0;
		}

		if (step === 3) {
			renderStep3ByFormat();
			updateStep3Buttons();
		}

		if (step === 4) {
			updateStep4Buttons();
		}

		if (step === 5) {
			renderStep5ByLine();
		}

		syncNextBtnState(step);
		currentStep = step;
	}

	function resetForm() {
		Object.keys(formData).forEach((key) => delete formData[key]);
		openerProductId = "";
		uploadedFiles = []; // zera a lista acumulada de anexos do passo 3
		modal.querySelectorAll("input").forEach((input) => {
			if (input.type === "checkbox") {
				input.checked = false;
			} else {
				input.value = "";
			}
		});
		modal.querySelectorAll(".option-btn.active").forEach((btn) => btn.classList.remove("active"));
		modal.querySelectorAll("[data-upload-filename]").forEach((el) => {
			el.textContent = "";
		});
		// Esvazia a lista visual de anexos (uploadedFiles já foi zerada acima)
		renderUploadList();
	}

	/** @param {string} [productId] */
	function openModal(productId) {

		const gclidField = modal.querySelector('#modal-gclid-field');
		if (gclidField) gclidField.value = win.__gclid || "";

		openerProductId = `${productId || ""}`.trim();

		// Try to load saved progress
		const savedProgress = loadProgress();
		if (savedProgress && savedProgress.step >= 1) {
			currentStep = savedProgress.step;
			Object.assign(formData, savedProgress.formData || {});
			if (savedProgress.productId) {
				openerProductId = savedProgress.productId;
			}
		} else {
			currentStep = 0;
		}

		if (openerProductId) {
			formData.sku = openerProductId;
		}
		modal.classList.remove("hidden");
		showStep(currentStep);
		document.body.classList.add("project-start-modal-open");
	}

	function closeModal(force = false) {
		// Nas etapas 2 a 11, o X NUNCA fecha direto: abre a confirmação de saída.
		if (!force && currentStep >= 2 && currentStep <= 9) {
			showConfirmExit();
			return; // Sempre aguarda a decisão do usuário no card.
		}

		modal.classList.add("hidden");
		hideConfirmExit();
		currentStep = 0;
		resetForm();
		clearProgress();
		document.body.classList.remove("project-start-modal-open");
	}

	/** @param {HTMLInputElement | null} field */
	function showFieldError(field) {
		if (!field) {
			return;
		}
		field.style.borderColor = "#e11923";
		field.style.boxShadow = "0 0 0 2px rgba(225, 25, 35, 0.1)";
	}

	/** @param {HTMLInputElement | null} field */
	function clearFieldError(field) {
		if (!field) {
			return;
		}
		field.style.borderColor = "";
		field.style.boxShadow = "";
	}

	/** @param {string} email */
	function isValidEmail(email) {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	}

	/**
	 * Máscara de telefone MEXICANO: 10 dígitos exibidos como "55 1234 5678".
	 *
	 * O padrão nacional do México é 10 dígitos separados por espaço, sem
	 * parênteses e sem hífen (isso era herança do formato brasileiro).
	 * Agrupamos em 2-4-4, que é a forma mais comum de exibição e cobre as
	 * LADAs de 2 dígitos das três maiores cidades (55 CDMX, 81 Monterrey,
	 * 33 Guadalajara). Cidades com LADA de 3 dígitos são oficialmente
	 * escritas como 3-3-4 (ex: 656 123 4567), mas detectar isso exigiria a
	 * tabela de LADAs do IFT — o agrupamento visual não altera o valor
	 * enviado, que vai só com dígitos.
	 * @param {string} value
	 */
	function formatMexicoPhone(value) {
		const digits = value.replace(/\D/g, "").slice(0, 10);
		if (!digits) return "";

		if (digits.length <= 2) return digits;
		if (digits.length <= 6) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
		return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
	}

	/**
	 * Telefone mexicano válido = exatamente 10 dígitos.
	 * @param {string} value
	 */
	function isValidMexicoPhone(value) {
		const digits = value.replace(/\D/g, "");
		return digits.length === 10;
	}

	/** @param {HTMLElement | null} stepElement */
	function getActiveOptionValue(stepElement) {
		if (!stepElement) return null;
		const activeBtn = /** @type {HTMLButtonElement | null} */ (stepElement.querySelector(".option-btn.active"));
		return activeBtn ? activeBtn.getAttribute("data-value") : null;
	}

	/** @param {HTMLElement | null} stepElement */
	function highlightOptionGroupError(stepElement) {
		if (!stepElement) return;
		const optionButtons = stepElement.querySelectorAll(".option-btn");
		optionButtons.forEach((btn) => {
			if (btn instanceof HTMLElement) {
				btn.style.borderColor = "#e11923";
			}
		});
	}

	/** @param {HTMLElement | null} stepElement */
	function clearOptionGroupError(stepElement) {
		if (!stepElement) return;
		const optionButtons = stepElement.querySelectorAll(".option-btn");
		optionButtons.forEach((btn) => {
			if (btn instanceof HTMLElement) {
				btn.style.borderColor = "";
			}
		});
	}

	function validateStep1() {
		const nome = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="nome"]'));
		const email = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="email"]'));
		const telefone = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="telefone"]'));
		let valid = true;

		if (!nome || !nome.value.trim()) {
			showFieldError(nome);
			valid = false;
		} else {
			clearFieldError(nome);
			formData.nome = nome.value;
		}

		if (!email || !email.value.trim() || !isValidEmail(email.value)) {
			showFieldError(email);
			valid = false;
		} else {
			clearFieldError(email);
			formData.email = email.value;
		}

		if (!telefone || !telefone.value.trim() || !isValidMexicoPhone(telefone.value)) {
			showFieldError(telefone);
			valid = false;
		} else {
			clearFieldError(telefone);
			formData.telefone = telefone.value;
		}

		return valid;
	}

	function validateCurrentStep() {
		if (currentStep === 0) {
			return true;
		}

		if (currentStep === 1) {
			return validateStep1();
		}

		const stepElement = /** @type {HTMLElement | null} */ (modal.querySelector(`.form-step[data-step="${currentStep}"]`));
		if (!stepElement) {
			return true;
		}

		if (currentStep === 2 || currentStep === 7 || currentStep === 9) {
			const selectedValue = getActiveOptionValue(stepElement);
			if (!selectedValue) {
				highlightOptionGroupError(stepElement);
				return false;
			}

			clearOptionGroupError(stepElement);
			if (currentStep === 2) {
				formData.format = selectedValue;
				formData.formato = selectedValue;
			}
			if (currentStep === 7) {
				formData.space_ready = selectedValue;
				formData.espacoPronto = selectedValue;
			}
			if (currentStep === 9) {
				formData.orcamento = selectedValue;
			}
			return true;
		}

		// Etapa 4 (linha) é opcional — segue mesmo sem seleção
		if (currentStep === 4) {
			const selectedValue = getActiveOptionValue(stepElement);
			clearOptionGroupError(stepElement);
			if (selectedValue) {
				formData.line = selectedValue;
			}
			return true;
		}

		if (currentStep === 5) {
			const activeColors = Array.from(stepElement.querySelectorAll(".step5-color-btn.active")).map((b) => b.getAttribute("data-value") || "");
			if (!activeColors.length) {
				highlightOptionGroupError(stepElement);
				return false;
			}
			clearOptionGroupError(stepElement);
			formData.color = activeColors.join(",");
			formData.cor = formData.color;
			return true;
		}

		if (currentStep === 3) {
			const allInputs = /** @type {NodeListOf<HTMLInputElement>} */ (stepElement.querySelectorAll('[data-step3-inputs] input'));
			for (const input of allInputs) {
				clearFieldError(input);
				if (input.value.trim()) {
					formData[input.name] = input.value;
				}
			}
			return true;
		}

		// Etapa 6 — profundidade da bancada. Agora é INCONDICIONAL: no BR ela
		// só aparecia para quem respondia que tinha/queria bancada (etapa 7,
		// removida no MX), então a pergunta passa a ser exibida sempre.
		if (currentStep === 6) {
			const depthCustom = /** @type {HTMLInputElement | null} */ (stepElement.querySelector('input[name="step8_depth_custom"]'));
			const activeValue = getActiveOptionValue(stepElement);
			const customValue = depthCustom ? depthCustom.value.replace(/[^0-9]/g, "").trim() : "";

			if (!activeValue && !customValue) {
				highlightOptionGroupError(stepElement);
				showFieldError(depthCustom);
				return false;
			}

			clearOptionGroupError(stepElement);
			clearFieldError(depthCustom);
			if (customValue) {
				formData.depth = `${customValue}cm`;
				formData.profundidade = formData.depth;
			} else if (activeValue) {
				formData.depth = activeValue;
				formData.profundidade = activeValue;
			}
			return true;
		}

		if (currentStep === 8) {
			const dataCompra = /** @type {HTMLInputElement | null} */ (stepElement.querySelector('input[name="data-compra"]'));
			if (!dataCompra || !dataCompra.value.trim() || dataCompra.value < dataCompra.min || dataCompra.value > dataCompra.max) {
				showFieldError(dataCompra);
				return false;
			}

			clearFieldError(dataCompra);
			formData.data_compra = dataCompra.value;
			return true;
		}

		return true;
	}

	function nextStep() {
		if (currentStep < totalSteps) {
			if (!validateCurrentStep()) {
				return;
			}
			const stepBeforeAdvance = currentStep;
			const advanceEvent = MODAL_STEP_ADVANCE_EVENTS[stepBeforeAdvance];
			if (advanceEvent) {
				trackProjetoEvent(advanceEvent, {});
			}
			// Captação antecipada do lead ao concluir o passo 1 (dados pessoais).
			if (stepBeforeAdvance === 1) {
				captureLead();
			}
			currentStep += 1;
			showStep(currentStep);
			return;
		}

		currentStep = totalSteps + 1;
		showStep(getStepElements().length - 1);
	}

	/**
	 * Pula a pergunta atual SEM validar (usado pelo botão "Pular esta pergunta"
	 * do card de confirmação de saída). Diferente de nextStep(): não bloqueia
	 * mesmo em etapas obrigatórias, e não dispara o evento de tracking da etapa.
	 */
	function skipCurrentStep() {
		hideConfirmExit();
		if (currentStep < totalSteps) {
			currentStep += 1;
			showStep(currentStep);
			return;
		}
		submitForm();
	}

	function goBack() {
		if (currentStep > totalSteps) {
			showStep(totalSteps);
			return;
		}

		if (currentStep > 0) {
			currentStep -= 1;
			showStep(currentStep);
			return;
		}
		closeModal();
	}

	async function submitForm() {
		if (isSubmitting) {
			return;
		}

		if (!validateCurrentStep()) {
			return;
		}

		trackProjetoEvent("orcamento_modal", {});

		const fileValidationError = validateUploadFiles(getUploadFiles());
		if (fileValidationError) {
			window.alert(fileValidationError);
			return;
		}

		isSubmitting = true;
		setSubmitLoading(true);

		// Upload de arquivo em paralelo (best-effort — nunca bloqueia o envio principal)
		try {
			const files = getUploadFiles();
			if (files.length) {
				submitFileViaHiddenIframe(`${formData.email || ""}`.trim(), files);
			}
		} catch (err) {
			console.error("[modal-projeto] Erro inesperado ao disparar upload de arquivo.", err);
		}

		// Envio final: inclui a origem de cadastro "normal" (staging) — é a
		// ÚNICA vez que essa origem é enviada nesta sessão (a captação
		// antecipada do passo 1 não envia mais origem nenhuma).
		const fields = buildHubspotFields(ORIGIN_STAGING_NORMAL);
		debugFields(fields);

		// IP best-effort (não bloqueia)
		let ip = "";
		try {
			ip = await fetch("https://api.ipify.org?format=json")
				.then((r) => r.json())
				.then((d) => d.ip)
				.catch(() => "");
		} catch (e) {
			ip = "";
		}

		try {
			await postToHubspot(fields, { ipAddress: ip });

			trackProjetoEvent("success_form", {});

			clearProgress(); // limpa progresso salvo após sucesso
			currentStep = totalSteps + 1;
			showStep(getStepElements().length - 1);
		} catch (error) {
			const message = error instanceof Error ? error.message : "Error inesperado al enviar el formulario.";
			console.error("[modal-projeto] Erro no envio:", error);
			window.alert(message);
		} finally {
			isSubmitting = false;
			setSubmitLoading(false);
		}
	}

	backBtn.addEventListener("click", goBack);
	closeBtn.addEventListener("click", () => closeModal(false));
	if (modalSuccessCloseBtn) {
    modalSuccessCloseBtn.addEventListener("click", () => closeModal(false));
	}

	// Confirm exit modal listeners — 3 opções, igual ao padrão NEO:
	// 1) Primário (vermelho): só fecha o card, volta pra pergunta.
	// 2) "Pular esta pergunta": pula SÓ a pergunta atual e segue no formulário.
	// 3) "Sair do formulário": registra a etapa de desistência na HubSpot
	//    (best-effort) + salva progresso local + fecha o modal.
	if (modalConfirmStayBtn) {
		modalConfirmStayBtn.addEventListener("click", () => {
			hideConfirmExit(); // volta pra pergunta atual, sem mais nenhuma ação
		});
	}

	if (modalConfirmSkipBtn) {
		modalConfirmSkipBtn.addEventListener("click", () => {
			skipCurrentStep();
		});
	}

	if (modalConfirmLeaveBtn) {
		modalConfirmLeaveBtn.addEventListener("click", () => {
			recordExit(EXIT_STEP[currentStep] || "");
			saveProgress();
			hideConfirmExit();
			modal.classList.add("hidden");
			document.body.classList.remove("project-start-modal-open");
		});
	}

	document.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;

		const openTrigger = e.target.closest("[data-project-start-open]");
		if (openTrigger) {
			e.preventDefault();
			const productId = getProductIdFromTrigger(openTrigger);
			openModal(productId);
		}
	});

	modal.addEventListener("click", (e) => {
		// Clicar fora do popup (no overlay) NÃO fecha o modal — o usuário só sai
		// pelo X (que passa pela confirmação) ou concluindo o formulário.
		// (listener de close-on-overlay removido de propósito.)
		if (!(e.target instanceof Element)) return;

		const optionBtn = /** @type {HTMLButtonElement | null} */ (e.target.closest(".option-btn"));
		if (optionBtn && optionBtn.closest(".form-step")) {
			const parent = optionBtn.parentElement;
			if (!parent) return;

			const stepElement = /** @type {HTMLElement | null} */ (optionBtn.closest(".form-step"));
			if (!stepElement) return;
			const stepNum = stepElement.getAttribute("data-step");

			// Step 5: multiple selection up to 2 colors
			if (stepNum === "5") {
				if (optionBtn.classList.contains("active")) {
					optionBtn.classList.remove("active");
				} else {
					const activeCount = parent.querySelectorAll(".option-btn.active").length;
					if (activeCount < 2) {
						optionBtn.classList.add("active");
					}
				}
				const activeColors = Array.from(parent.querySelectorAll(".option-btn.active")).map((b) => b.getAttribute("data-value") || "");
				formData.color = activeColors.join(",");
				formData.cor = formData.color;
				clearOptionGroupError(stepElement);
			} else {
				parent.querySelectorAll(".option-btn").forEach((btn) => btn.classList.remove("active"));
				optionBtn.classList.add("active");

				const value = optionBtn.getAttribute("data-value");
				clearOptionGroupError(stepElement);

				switch (stepNum) {
					case "2":
						formData.format = value;
						formData.formato = value;
						renderStep3ByFormat();
						break;
					case "4":
						formData.line = value;
						updateStep4Buttons();
						break;
					case "6":
						formData.depth = value;
						formData.profundidade = value;
						const depthCustomInput = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="step8_depth_custom"]'));
						if (depthCustomInput) {
							depthCustomInput.value = "";
						}
						break;
					case "7":
						formData.space_ready = value;
						formData.espacoPronto = value;
						break;
					case "9":
						formData.orcamento = value;
						break;
					default:
						break;
				}
			}
		}

		syncNextBtnState(currentStep);

		if (e.target.closest("[data-next-step]")) {
			nextStep();
		}

		if (e.target.closest("[data-submit]")) {
			submitForm();
		}
	});

	const dateInput = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="data-compra"]'));
	if (dateInput) {
		// Campo é <input type="month">: min/max devem estar no formato "YYYY-MM"
		// (o código anterior usava "YYYY-MM-DD", formato errado pra este tipo).
		// Regra: mês atual em diante, limitado a 1 ano à frente (janela rolante).
		const today = new Date();
		const yyyy = today.getFullYear();
		const mm = String(today.getMonth() + 1).padStart(2, "0");
		dateInput.min = `${yyyy}-${mm}`;
		dateInput.max = `${yyyy + 1}-${mm}`;

		dateInput.addEventListener("click", () => {
			try { dateInput.showPicker(); } catch (_) {}
		});

		dateInput.addEventListener("focus", () => {
			try { dateInput.showPicker(); } catch (_) {}
		});

		dateInput.addEventListener("change", () => {
			if (!dateInput.value || dateInput.value < dateInput.min || dateInput.value > dateInput.max) {
				showFieldError(dateInput);
			} else {
				clearFieldError(dateInput);
			}
			syncNextBtnState(currentStep);
		});
	}

	const depthCustomEl = /** @type {HTMLInputElement | null} */ (modal.querySelector('input[name="step8_depth_custom"]'));
	if (depthCustomEl) {
		depthCustomEl.addEventListener("input", function () {
			const suf = unitCmSuffix();
			const numeric = this.value.replace(/[^0-9]/g, "");
			if (numeric) {
				this.value = numeric + suf;
				this.setSelectionRange(numeric.length, numeric.length);
			} else {
				this.value = "";
			}
		});
		depthCustomEl.addEventListener("blur", function () {
			const suf = unitCmSuffix();
			const numeric = this.value.replace(/[^0-9]/g, "");
			this.value = numeric ? numeric + suf : "";
		});
	}

	modal.addEventListener("change", (e) => {
		if (!(e.target instanceof HTMLInputElement)) return;

		if (e.target.name === "nome") formData.nome = e.target.value;
		if (e.target.name === "email") formData.email = e.target.value;
		if (e.target.name === "telefone") formData.telefone = e.target.value;
		if (/^parede\d+$/.test(e.target.name)) {
			formData[e.target.name] = e.target.value;
		}
		if (e.target.name === "data-compra") {
			formData.data_compra = e.target.value;
		}

		if (e.target.name === "step8_depth_custom") {
			const step8 = /** @type {HTMLElement | null} */ (modal.querySelector('.form-step[data-step="6"]'));
			if (step8) {
				step8.querySelectorAll(".option-btn").forEach((btn) => btn.classList.remove("active"));
			}

			const rawValue = e.target.value.replace(/[^0-9]/g, "").trim();
			if (rawValue) {
				formData.depth = `${rawValue}cm`;
				formData.profundidade = formData.depth;
			} else {
				delete formData.depth;
				delete formData.profundidade;
			}
		}

		if (e.target.name === "step3_space_file") {
			// ACUMULA os arquivos entre seleções. Comportamento nativo do
			// <input type="file"> é SUBSTITUIR input.files a cada nova escolha —
			// então guardamos a lista acumulada em uploadedFiles e reescrevemos
			// input.files (via DataTransfer) pra ela virar a fonte de verdade.
			const novos = e.target.files ? Array.from(e.target.files) : [];
			novos.forEach((f) => {
				const chave = `${f.name}|${f.size}|${f.lastModified}`;
				const jaExiste = uploadedFiles.some(
					(x) => `${x.name}|${x.size}|${x.lastModified}` === chave,
				);
				if (!jaExiste) uploadedFiles.push(f);
			});

			syncUploadInput();
			renderUploadStatus();
		}

	});

	modal.addEventListener("input", (e) => {
		if (!(e.target instanceof HTMLInputElement)) return;

		if (e.target.name === "telefone") {
			e.target.value = formatMexicoPhone(e.target.value);
			formData.telefone = e.target.value;
			syncNextBtnState(currentStep);
		}

		if (e.target.name === "email" || e.target.name === "nome" || /^parede\d+$/.test(e.target.name) || e.target.name === "data-compra") {
			clearFieldError(e.target);
			if (e.target.name === "email" || e.target.name === "nome") {
				syncNextBtnState(currentStep);
			}
			if (/^parede\d+$/.test(e.target.name)) {
				updateStep3Buttons();
			}
		}


		if (e.target.name === "step8_depth_custom" && e.target.value.replace(/[^0-9]/g, "").trim()) {
			const step8 = /** @type {HTMLElement | null} */ (modal.querySelector('.form-step[data-step="6"]'));
			clearOptionGroupError(step8);
			clearFieldError(e.target);
			syncNextBtnState(currentStep);
		}
	});

	// Remover arquivo anexado por engano (passo 3). Delegação de evento porque
	// a lista é re-renderizada a cada mudança. Registrado UMA única vez aqui,
	// junto aos outros listeners — nunca dentro de função chamada repetidamente.
	modal.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;
		const removeBtn = e.target.closest("[data-upload-remove]");
		if (!removeBtn) return;
		e.preventDefault();
		e.stopPropagation();
		const index = Number(removeBtn.getAttribute("data-upload-remove"));
		if (!Number.isNaN(index)) removeUploadFile(index);
	});

	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape" || modal.classList.contains("hidden")) return;

		// Na tela final o X do cabeçalho fica escondido de propósito (só
		// WhatsApp e Continuar). Se o ESC ainda fechasse, a regra ficaria
		// incoerente: bloqueada no clique e aberta no teclado.
		const modalContainer = modal.querySelector(".modal-container");
		if (modalContainer && modalContainer.classList.contains("is-success-step")) return;

		closeModal();
	});
})();